import React from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { KPICard } from '../../components/ui/KPICard';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { StatusPill } from '../../components/ui/StatusPill';
import { UsersIcon, ClockIcon, AlertTriangleIcon, CheckCircleIcon } from 'lucide-react';
const pipelineData = [{
  stage: 'Company Details',
  count: 2,
  sla: 'On Track'
}, {
  stage: 'Tax & Registration',
  count: 1,
  sla: 'On Track'
}, {
  stage: 'Bank Verification',
  count: 2,
  sla: '1 Overdue'
}, {
  stage: 'Compliance Review',
  count: 3,
  sla: '2 Overdue'
}, {
  stage: 'Document Upload',
  count: 1,
  sla: 'On Track'
}, {
  stage: 'Ready for Activation',
  count: 3,
  sla: 'Action Required'
}];
export const OnboardingCommandPage: React.FC = () => {
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-445">
      <PageHeader title="Onboarding Command Center" description="Manage the supplier onboarding pipeline and SLAs." primaryAction={<Button data-id="element-447">Invite Supplier</Button>} data-id="element-446" />

      <div className="grid grid-cols-1 md:grid-cols-5 gap-4" data-id="element-448">
        <KPICard title="Total Pipeline" value="12" icon={<UsersIcon className="w-5 h-5" data-id="element-450" />} data-id="element-449" />
        <KPICard title="Awaiting Review" value="5" icon={<ClockIcon className="w-5 h-5 text-status-warning" data-id="element-452" />} data-id="element-451" />
        <KPICard title="Blocked" value="2" icon={<AlertTriangleIcon className="w-5 h-5 text-status-error" data-id="element-454" />} data-id="element-453" />
        <KPICard title="Ready for Activation" value="3" icon={<CheckCircleIcon className="w-5 h-5 text-status-success" data-id="element-456" />} data-id="element-455" />
        <KPICard title="Avg Days to Activate" value="18" icon={<ClockIcon className="w-5 h-5" data-id="element-458" />} trend="down" trendValue="-2 days" data-id="element-457" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-459">
        <div className="lg:col-span-2 space-y-6" data-id="element-460">
          <Card data-id="element-461">
            <h2 className="text-lg font-semibold text-text-primary mb-4" data-id="element-462">
              Pipeline by Stage
            </h2>
            <div className="space-y-3" data-id="element-463">
              {pipelineData.map((item, idx) => <div key={idx} className="flex items-center justify-between p-4 border border-border-light rounded-fluent bg-surface-secondary hover:bg-gray-100 cursor-pointer transition-colors" data-id="element-464">
                  <div className="flex items-center gap-4" data-id="element-465">
                    <div className="w-8 h-8 rounded-full bg-fpg-navy text-white flex items-center justify-center font-bold text-sm" data-id="element-466">
                      {item.count}
                    </div>
                    <span className="font-medium text-text-primary" data-id="element-467">
                      {item.stage}
                    </span>
                  </div>
                  <span className={`text-sm font-medium ${item.sla.includes('Overdue') || item.sla.includes('Action') ? 'text-status-error' : 'text-status-success'}`} data-id="element-468">
                    {item.sla}
                  </span>
                </div>)}
            </div>
          </Card>
        </div>
        <div className="space-y-6" data-id="element-469">
          <Card className="border-l-4 border-l-status-error" data-id="element-470">
            <h2 className="text-lg font-semibold text-text-primary mb-4 flex items-center gap-2" data-id="element-471">
              <AlertTriangleIcon className="w-5 h-5 text-status-error" data-id="element-472" />{' '}
              Blocker Alerts
            </h2>
            <div className="space-y-3" data-id="element-473">
              <div className="p-3 bg-surface-secondary rounded-fluent text-sm" data-id="element-474">
                <p className="font-medium text-text-primary mb-1" data-id="element-475">
                  Duplicate Tax ID Detected
                </p>
                <p className="text-text-secondary" data-id="element-476">
                  Supplier "FreshCo Trading" matches existing tax ID.
                </p>
                <Button variant="ghost" size="sm" className="mt-2 text-fpg-navy p-0" data-id="element-477">
                  Review Match
                </Button>
              </div>
              <div className="p-3 bg-surface-secondary rounded-fluent text-sm" data-id="element-478">
                <p className="font-medium text-text-primary mb-1" data-id="element-479">
                  Sanctions Hit
                </p>
                <p className="text-text-secondary" data-id="element-480">
                  Potential match found for "Global Foods Ltd".
                </p>
                <Button variant="ghost" size="sm" className="mt-2 text-fpg-navy p-0" data-id="element-481">
                  Review Report
                </Button>
              </div>
            </div>
          </Card>
          <Card data-id="element-482">
            <h2 className="text-lg font-semibold text-text-primary mb-4" data-id="element-483">
              ERP Sync Status
            </h2>
            <div className="space-y-2" data-id="element-484">
              <div className="flex justify-between items-center text-sm" data-id="element-485">
                <span className="text-text-secondary" data-id="element-486">SAP S/4HANA</span>
                <StatusPill status="Active" data-id="element-487" />
              </div>
              <div className="flex justify-between items-center text-sm" data-id="element-488">
                <span className="text-text-secondary" data-id="element-489">Last Sync</span>
                <span className="font-medium" data-id="element-490">10 mins ago</span>
              </div>
              <div className="flex justify-between items-center text-sm" data-id="element-491">
                <span className="text-text-secondary" data-id="element-492">Pending Records</span>
                <span className="font-medium" data-id="element-493">0</span>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>;
};